import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import Section_name from "../ipillion/Section_name";
import { useRouter } from "next/router";
const What_ez = () => {
  const router = useRouter();
  const lang = router.locale;
  const t = useTranslations("ez_credit.whats_ez");
  return (
    <div>
      <div className="flex lg:flex-row flex-col  lg:justify-between justify-center items-center gap-[30px] ">
        <div>
          <Section_name name={t("header")} color={"#C29D3E"} />
          <p className="max-w-[472px] w-[90%] text-[16px] text-[#002046] lg:font-[400] font-[700] leading-[20px]">
            {t("text")}
          </p>
          <p className="max-w-[472px] w-[90%] pt-3 text-[16px] text-[#002046] lg:font-[400] font-[700] leading-[20px]">
            {t("text2")}
          </p>
        </div>
        <div className="lg:w-max w-full">
          <div
            className={`${
              lang == "ar" && "-scale-x-100"
            } relative lg:h-[274px] lg:w-[476.01px] w-[300px] responsive h-[201.47px]`}
          >
            <Image src="/ez_credit/credit.png" layout="fill" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default What_ez;
